/* eslint-disable no-unused-expressions */
import {Power0} from 'gsap';

// let scheme = null;
let svgScheme = '.chapter-position .chapter-fixed__figure.scheme-5 svg';
let scheme = document.querySelector(svgScheme);
let manipulatorel3 = null;
let manipulatorel4 = null;
let manipulatorel5 = null;
let manipulatorel6 = null;
let manipulatorel7 = null;
let sensorSection = null;
let manipulatorColor = null;

let fullAnimation = null;

const play = () => {
	if (fullAnimation && fullAnimation.paused()) {
		fullAnimation.play();
	}
};

const pause = () => {
	if (fullAnimation && !fullAnimation.paused()) {
		fullAnimation.pause();
	}
};

const getFill = (el) => {
	return el.dataset.fill;
};
const setStrokeDashoffset = (el) => {
	const path = el.getTotalLength();
	gsap.set(el, {
		strokeDashoffset: path,
		strokeDasharray: `${path}, ${path}`,
	});
};

const reset = () => {
	const tm = gsap.timeline();

	scheme = document.querySelector('.chapter-fixed__figure.scheme-5 svg');
	sensorSection = document.querySelector('.chapter-fixed__figure.scheme-5 .chapter-fixed__sensors');
	manipulatorel3 = document.querySelector('.chapter-fixed__manipulator--item.chapter-fixed__manipulator--item-3');
	manipulatorel4 = document.querySelector('.chapter-fixed__manipulator--item.chapter-fixed__manipulator--item-4');
	manipulatorel5 = document.querySelector('.chapter-fixed__manipulator--item.chapter-fixed__manipulator--item-5');
	manipulatorel6 = document.querySelector('.chapter-fixed__manipulator--item.chapter-fixed__manipulator--item-6');
	manipulatorel7 = document.querySelector('.chapter-fixed__manipulator--item.chapter-fixed__manipulator--item-7');
	manipulatorColor = document.querySelectorAll('.chapter-fixed__manipulator--item .manipulator-color');

	const parent = scheme.querySelector('.vibration-sensor');
	const highlightGropup = scheme.querySelectorAll('.highlight-group');
	const vibrationCircle = parent.querySelectorAll('.vibration-sensor-circle');
	const vibrationSensor = parent.querySelectorAll('.vibration-sensor-figure');
	const rect = parent.querySelectorAll('.vibration-sensor-figure--rect--fill');
	const figureStroke = parent.querySelectorAll('.vibration-sensor-figure--stroke');
	const lines = scheme.querySelectorAll('.lines-group .lines');
	const colorLines = scheme.querySelectorAll('.lines-group-show-color .lines path');
	const glass = scheme.querySelector('.machine-glass');
	const machineStroke = scheme.querySelector('.machine-stroke');
	const persone = scheme.querySelector('.person-group-gradient');
	const personeStroke = scheme.querySelector('.person-group-stroke');
	const lineDottedMask = scheme.querySelector('.line-dotted-mask');
	const sensorsCircles = sensorSection.querySelectorAll('.sensors-circles path');
	const sensorsColor = sensorSection.querySelectorAll('.sensors-projector-color');

	setStrokeDashoffset(machineStroke);
	setStrokeDashoffset(lineDottedMask);

	tm
		.set(sensorSection, {
			x: -10,
			y: -1,
			rotate: -11,
			transformOrigin: '50% 50%',
		})
		.set(manipulatorel3, {
			x: -10,
			y: -1,
			rotate: -12,
			transformOrigin: '50% 50%',
		})
		.set(manipulatorel4, {
			x: -12,
			y: 0,
			rotate: -11,
			transformOrigin: '50% 50%',
		})
		.set(manipulatorel5, {
			x: -12,
			y: 0,
			rotate: -11,
			transformOrigin: '50% 50%',
		})
		.set(manipulatorel6, {
			x: -11,
			y: 0,
			rotate: -11,
			transformOrigin: '50% 50%',
		})
		.set(manipulatorel7, {
			x: -10,
			y: -1,
			rotate: -11,
			transformOrigin: '50% 50%',
		})
		.set([colorLines, personeStroke], {
			stroke: '#75ABFF',
		})
		.set(rect, {
			autoAlpha: 0,
		})
		.set(vibrationSensor, {
			scaleX: 0,
			scaleY: 0,
			x: 100,
			y: 100,
		});

	vibrationSensor.forEach((element) => {
		const vibrationSensorCircle = element.querySelector('.vibration-sensor-figure-circle');
		setStrokeDashoffset(vibrationSensorCircle);
	});

	vibrationCircle.forEach((element) => {
		setStrokeDashoffset(element);
	});

	figureStroke.forEach((element) => {
		setStrokeDashoffset(element);
	});

	lines.forEach((element) => {
		const defaultLine = element.querySelector('.lines-default');

		if (defaultLine) {
			setStrokeDashoffset(defaultLine);
		}
	});

	highlightGropup.forEach((element) => {
		const highlight = element.querySelector('.highlight-default');
		const highlightGradient = element.querySelector('.highlight-gradient');
		const gradientCamer = element.querySelector('.highlight-group-camera-gradiend');

		tm
			.set([
				highlight, highlightGradient, gradientCamer,
				glass, persone, manipulatorColor, sensorsCircles, sensorsColor,
			], {
				autoAlpha: 0,
			}, 0);
	});
};

const machineAnimate = () => {
	const tm = gsap.timeline();
	fullAnimation.add(tm.play(), 'tmVibration');
	const glass = scheme.querySelector('.machine-glass');
	const machineStroke = scheme.querySelector('.machine-stroke');
	const color = getFill(machineStroke);

	tm
		.to(machineStroke, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: 10,
		}, 0)
		.to(machineStroke, {
			stroke: color,
			ease: Power0.easeInOut,
			duration: 2,
			stagger: 0.2,
			delay: 0.75,
		}, 0)
		.to(glass, {
			ease: Power0.easeInOut,
			autoAlpha: 1,
			duration: 3,
			stagger: 0,
		}, 1);
};

const sensorsAnimate = () => {
	const tm = gsap.timeline();
	const tmCircles = gsap.timeline({repeat: -1,
		yoyo: true});
	const time = 0.5;
	const sensorsCircles = sensorSection.querySelectorAll('.sensors-circles path');
	const sensorsColor = sensorSection.querySelectorAll('.sensors-projector-color');

	fullAnimation.add(tm.play(), 'highlightGropup');
	fullAnimation.add(tmCircles.play(), 'highlightGropup');

	tm
		.to(sensorsColor, time, {
			ease: Power0.easeInOut,
			autoAlpha: 1,
		})

		.to(sensorsColor, time, {
			ease: Power0.easeInOut,
			autoAlpha: 1,
		});

	tmCircles
		.to(sensorsCircles, 0.35, {
			ease: Power0.easeInOut,
			autoAlpha: 1,
			stagger: 0.25,
		});
};

const manipulatorAnimate = () => {
	const time = 1;
	const tm = gsap.timeline({repeat: -1,
		yoyo: true});
	fullAnimation.add(tm.play(), 'personAnimate');
	tm
		.to(manipulatorel3, {
			x: -3,
			y: 4,
			ease: Power0.easeInOut,
			duration: time,
			rotate: -25,
			transformOrigin: '50% 50%',
		}, 0)
		.to(manipulatorel4, {
			x: -3,
			y: 5,
			ease: Power0.easeInOut,
			duration: time,
			rotate: -22,
			transformOrigin: '50% 50%',
		}, 0)
		.to(manipulatorel5, {
			x: -12,
			y: 0,
			rotate: -11,
			ease: Power0.easeInOut,
			duration: time,
			transformOrigin: '50% 50%',
		}, 0)
		.to(manipulatorel6, {
			x: -11,
			y: 0,
			rotate: -11,
			ease: Power0.easeInOut,
			duration: time,
			transformOrigin: '50% 50%',
		}, 0)
		.to(manipulatorel7, {
			x: -4,
			y: 8,
			rotate: -13,
			ease: Power0.easeInOut,
			duration: time,
			transformOrigin: '50% 50%',
		}, 0)
		.to(sensorSection, {
			x: -11,
			y: -2,
			rotate: -11,
			ease: Power0.easeInOut,
			duration: time,
			transformOrigin: '50% 50%',
		}, 0)
		.to(manipulatorel3, {
			x: -10,
			y: -6,
			rotate: 7,
			ease: Power0.easeInOut,
			duration: time,
			transformOrigin: '50% 50%',
		}, time)
		.to(manipulatorel4, {
			x: -10,
			y: -6,
			ease: Power0.easeInOut,
			duration: time,
			rotate: 6,
			transformOrigin: '50% 50%',
		}, time)
		.to(manipulatorel5, {
			x: -8,
			y: -2,
			rotate: 0,
			ease: Power0.easeInOut,
			duration: time,
			transformOrigin: '50% 50%',
		}, time)
		.to(manipulatorel6, {
			x: -6,
			y: 0,
			rotate: -6,
			ease: Power0.easeInOut,
			duration: time,
			transformOrigin: '50% 50%',
		}, time)
		.to(manipulatorel7, {
			x: -11,
			y: -5,
			rotate: 10,
			ease: Power0.easeInOut,
			duration: time,
			transformOrigin: '50% 50%',
		}, time)
		.to(sensorSection, {
			x: -6,
			y: -3,
			rotate: 1,
			ease: Power0.easeInOut,
			duration: time,
			transformOrigin: '50% 50%',
		}, time);
};

const personAnimate = () => {
	const tm = gsap.timeline();
	fullAnimation.add(tm.play(), 'highlightGropup').addLabel('personAnimate', 'highlightGropup+=0.5');
	const time = 0.5;
	const persone = scheme.querySelector('.person-group-gradient');
	const personeStroke = scheme.querySelector('.person-group-stroke');
	const color = getFill(personeStroke);
	const lineDotted = scheme.querySelector('.line-dotted');
	const lineDottedColor = getFill(lineDotted);
	const rect = scheme.querySelector('.vibration-sensor-figure--rect--fill');

	tm
		.to(personeStroke, {
			ease: Power0.easeInOut,
			stroke: color,
			duration: time,
			stagger: 0,
		}, 0)
		.to(persone, {
			autoAlpha: 1,
			duration: time,
			stagger: 0,
		}, 0)
		.to(lineDotted, {
			duration: 30,
			strokeDashoffset: 488,
			ease: 'none',
			repeat: -1,
		})
		.to(lineDotted, {
			ease: Power0.easeInOut,
			stroke: lineDottedColor,
			duration: time,
			stagger: 0,
		}, 0.2)
		.to([rect], {
			autoAlpha: 1,
			duration: time,
			stagger: 0,
		}, 0.4)
		.to([manipulatorColor], {
			autoAlpha: 1,
			duration: time,
			stagger: 0,
		}, 0.3);
};

const highlightGropupAnimate = () => {
	const highlightGropup = scheme.querySelectorAll('.highlight-group');

	highlightGropup.forEach((element) => {
		const highlightGradient = element.querySelector('.highlight-gradient');
		const time = 0.5;
		const tm = gsap.timeline();
		fullAnimation.addLabel('highlightGropup', 'showElements').add(tm.play(), 'showElements');

		tm
			.to(highlightGradient, {
				autoAlpha: 1,
				duration: time,
			});
	});
};

const showElements = () => {
	const tm = gsap.timeline();
	fullAnimation.addLabel('showElements', 'vibrationSensorAnimate+=0.15').add(tm.play(), 'vibrationSensorAnimate');
	const time = 0.75;
	const lineDottedMask = scheme.querySelector('.line-dotted-mask');

	const highlightGropup = scheme.querySelector('.highlight-group');
	const highlight = highlightGropup.querySelector('.highlight-default');
	const colorLines = scheme.querySelectorAll('.lines-group-show-color .lines path');

	const color = getFill(lineDottedMask);
	tm
		.to(lineDottedMask, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
		})
		.to(highlight, {
			ease: Power0.easeInOut,
			autoAlpha: 1,
			duration: time,
		}, 1)
		.to(colorLines, {
			ease: Power0.easeInOut,
			stroke: color,
			duration: time,
		}, 0.35);
};

const vibrationSensorAnimate = () => {
	const tm = gsap.timeline();
	const tmVibration = gsap.timeline();
	const parent = scheme.querySelector('.vibration-sensor');
	const line = parent.querySelectorAll('.vibration-sensor-circle');
	const vibrationSensor = parent.querySelector('.vibration-sensor-figure');
	const vibrationSensorCircle = parent.querySelector('.vibration-sensor-figure-circle');
	const figureStroke = parent.querySelectorAll('.vibration-sensor-figure--stroke');
	const color = '#E0A672';
	const time = 0.75;

	fullAnimation.addLabel('vibrationSensorAnimate', 0.5).add(tm.play(), 0.5);
	fullAnimation.addLabel('tmVibration', 0.5).add(tmVibration.play(), 0.5);

	tm
		.to(line, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
		})
		.to(line, {
			ease: Power0.easeInOut,
			duration: time,
			stroke: color,
		}, time / 2);

	tmVibration
		.to(vibrationSensor, {
			scaleX: 1,
			scaleY: 1,
			x: 0,
			y: 0,
			duration: time,
			onStart: () => {
				setTimeout(() => {
					// machineAnimate();
				}, 350);
			},
		}, 0)
		.to(vibrationSensorCircle, {
			ease: Power0.easeInOut,
			strokeDashoffset: 0,
			duration: time,
		}, 0)
		.to(vibrationSensorCircle, {
			ease: Power0.easeInOut,
			stroke: color,
			duration: time,
		}, time / 2);

	if (figureStroke.length) {
		tmVibration
			.to(figureStroke, {
				ease: Power0.easeInOut,
				strokeDashoffset: 0,
				duration: time,
				stagger: 0,
			}, 0)
			.to(figureStroke, {
				ease: Power0.easeInOut,
				stroke: color,
				duration: time,
				stagger: 0,
			}, time / 2);
	}
};

const startAnimeProgressLine = () => {
	const lines = scheme.querySelectorAll('.lines-group .lines');

	lines.forEach((element) => {
		const tm = gsap.timeline();
		fullAnimation.add(tm.play(), 0);
		const defaultLine = element.querySelector('.lines-default');
		const time = 2.5;
		tm
			.to(defaultLine, {
				ease: Power0.easeInOut,
				strokeDashoffset: 0,
				duration: time,
				stagger: 0.05,
			})
			.to(defaultLine, {
				stroke: '#E0A672',
				ease: Power0.easeInOut,
				duration: 0.75,
				stagger: 0.05,
				delay: 0.5,
			});
	});
};

const create = () => {
	fullAnimation = gsap.timeline({paused: true});
	startAnimeProgressLine();
	highlightGropupAnimate();
	vibrationSensorAnimate();
	sensorsAnimate();
	personAnimate();
	showElements();
	machineAnimate();
	manipulatorAnimate();
};

const init = () => {
	reset();
	create();
};

export default {
	init,
	reset,
	play,
	pause,
};
